var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"align-center justify-center d-flex",staticStyle:{"cursor":"e-resize"},on:{"mousedown":_vm.startResizeSidebar}},[_c('v-icon',[_vm._v(" mdi-drag-vertical-variant")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }